import React from "react";
import { Stack, Typography } from "@mui/material";
import { Done, Close } from "@mui/icons-material";

interface VendorResult {
  vendorKey: string;
  message: string;
}

interface VendorStatusProps {
  vendorResults: VendorResult[];
  customer?: {
    punchhId?: string;
  };
}

export const VendorStatus = ({ vendorResults, customer }: VendorStatusProps) => {
  const getVendorStatus = (vendorKey: string) => {
    // Special case: Punchh shows green if customer has a punchhId
    if (vendorKey === "Punchh" && customer?.punchhId) {
      return true;
    }
    
    const message = vendorResults?.find((vendor) => vendor.vendorKey === vendorKey)?.message;
    return message?.toLowerCase() === "success";
  };

  const renderVendorRow = (label: string, vendorKey: string) => (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="body2" fontWeight={600}>{label}:</Typography>
      {getVendorStatus(vendorKey) ? 
        <Done color="success" sx={{ fontSize: 18 }} /> : 
        <Close color="error" sx={{ fontSize: 18 }} />
      }
    </Stack>
  );

  return (
    <Stack spacing={1}>
      {renderVendorRow("Zax Admin", "ZaxbysAdmin")}
      {renderVendorRow("CDP", "CDP")}
      {renderVendorRow("Cognito", "Cognito")}
      {renderVendorRow("Punchh", "Punchh")}
      {renderVendorRow("Olo", "Olo")}
      {renderVendorRow("Radar", "Radar")}
    </Stack>
  );
};
